/*
 * File: 考勤点配置
 */
<template>
    <div class="attendanceRuleList">
        <p class="title">
            考勤点列表
            <el-button class="addNewAddr" type="primary" @click="openDialog">新增考勤点</el-button>
        </p>

        <Paper class="attendanceRuleList-paper">
            <list-layout-paper>
                <!-- 表格 -->
                 <template v-slot:list="{ tableHeight }">
                    <edit-table-box
                        ref="editTableBox"
                        key="attendanceLocationSettings"
                        v-loading="locationList.tableLoading"
                        :index="config.index"
                        :selection="config.selection"
                        :columns="config.columns"
                        :tableData="locationList.totalData"
                        :actions="config.actions"
                        :height="tableHeight"
                        :allowRowClick="false"
                        @btn-event="handleActive"
                    >
                        <template v-slot:col-append="{ item, row }">
                            <p class="addressName">{{ row['locationName'] }}</p>
                            <p class="addressName">{{ row['address'] }}</p>
                        </template>
                        <template v-slot:edit-col-append="{ item, row }">
                            <p class="addressName">{{ row['locationName'] }}</p>
                            <p class="addressName">{{ row['address'] }}</p>
                        </template>
                    </edit-table-box>
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="locationList.sizeChange"
                        :current-page.sync="locationList.pageNo"
                        @current-change="locationList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="locationList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>

            <!-- 新增合同弹窗 -->
            <add-Location-Dialog
                ref="map"
                @finish="updateFinish"
            >
            </add-Location-Dialog>
        </Paper>
    </div>
</template>

<script>
import { ref, reactive, onMounted, inject } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import { handleDictionaryDataString, formatDictCodeToName } from '@/modules/mdm/utils.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import editTableBox from '@/components/lots/editTableBox/Index';
import { getListLocation, deleteLocation } from '@/api/attendanceRuleSettings.js';
import { locationConfig as configStatic } from './config';
import addLocationDialog from './dialog.vue';

export default {
    name: 'revenueFactor',
    components: {
        Paper,
        listLayoutPaper,
        editTableBox,
        lotsPagination,
        addLocationDialog
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // 从父组件注入 ruleId
        const ruleId = inject('ruleId').value;
        const config = reactive(configStatic);

        class ListClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.ruleId = ruleId;
                return condition;
            };

            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list;
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        }

        const locationList = new ListClass({
            Api: {
                listApi: getListLocation // 查询接口
            }
        });

        // 新增
        const openDialog = (data) => {
            setupContext.refs.map.open();
        };

        // 操作项
        const handleActive = (row, event) => {
            // 编辑
            if (event === 'editOpera') {
                setupContext.refs.map.open(row);
            }
            // 启用
            if (event === 'delete') {
                deleteRow(row);
            }
        };

        // 删除
        const deleteRow = (row) => {
            MessageBox.confirm('此操作将删除考勤点' + row.address + ',是否继续？', '温馨提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                locationList.tableLoading.value = true;
                deleteLocation(row.id).then(res => {
                    if (+res.code === 0) {
                        Message.success('删除成功');
                        locationList.getList();
                    }
                }).finally(() => {
                    locationList.tableLoading.value = false;
                });
            });
        };

        const updateFinish = (data) => {
            // console.log('更新完成:', data);
            locationList.getList();
        };

        onMounted(() => {
            locationList.getList();
        });

        return {
            locationList,
            config,
            formatDictCodeToName,
            handleDictionaryDataString,
            openDialog,
            handleActive,
            updateFinish
        };
    }
};
</script>

<style lang="less">
.title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
    position: relative;

    .addNewAddr {
        position: absolute;
        right: 0;
        top: 0;
    }
}
.addressName {
    margin: 0;
}
.attendanceRuleList {
    width: 100%;
    height: 450px;
    .attendanceRuleList-paper {
        height: 100%;
    }
    .header-button {
        margin-left: 10px;
    }
    .search-box .el-select .el-input input {
        height: 28px!important;
    }
    .list-layout-wrapper {
        height: 100%;
        box-shadow: 0 0 0 #f2f2f2;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .layout-content.attendanceRuleList-paper {
        padding: 0px 0px 0px;
    }
}
</style>
